import { Identifiable, List } from "@planzone/dto";
import { Boundaries } from "@planzone/core";

function handleRemoveEvent(
  list: Identifiable<List>,
  event: Boundaries["removeEvent"]["success"],
): Identifiable<List> {
  return {
    ...list,
    events: list.events.filter(({ uuid }) => event.uuid !== uuid),
    subLists: list.subLists.map((subList) => handleRemoveEvent(subList, event)),
  };
}

export { handleRemoveEvent };
